import React, { useEffect, useState, ChangeEvent, MouseEvent, FocusEvent } from 'react'
import { useForm } from 'react-hook-form'
import {
    Containner,
    Chart,
    Causes,
    Line,
    EffectContainner,
    EffectItem,
    TitleEffect
} from 'components/Ishikawa/style'

import {
    IIshikawaDiagram,
    IIshikawaCategory
} from 'components/Ishikawa/types'

import {
    Modal

} from 'components/Ishikawa/modal'
import GetTopCausesContent from './components/GetTopCausesContent'
import GetBottomCausesContent from './components/GetBottomCausesContent'

interface IshikawaProps {
    data: IIshikawaDiagram
}
/**
 * Compoenente usado para rederizar de um diagrama Ishikawa
 * @param param0 
 */
const Ishikawa: React.FC<IshikawaProps> = ({ data, ...rest }) => {

    const { control, register, getValues, watch, handleSubmit, setValue } = useForm()

    /**
     * Estado que controla popup para cadastrar causas.
     */
    const [isEditing, setEditing] = useState<boolean>(false)

    const [editingCauseIndex, setEditingCauseIndex] = useState<number>()

    const [typeModal, setTypeModal] = useState<string>()
    /**
     * Estado que controla popup para cadastrar causas.
     */
    const [isOpenModal, setOpenModal] = useState<boolean>(false)
    /**
     * Estado que mantém o principal diagrama selecionado
     */
    const [currentDiagram, setCurrentDiagram] = useState<IIshikawaDiagram>()
    /**
     * Estado que mantém o principal diagrama selecionado
     */
    const [currentCategory, setCurrentCategory] = useState<string>()

    const selectedValue: string = watch('selectedValue')

    /**
     * Evento de duplo click para categotias e subcategorias do diagrama
     * @param event 
     * @param category 
     */
    const handleDoubleClick = (event: MouseEvent<HTMLSpanElement>, category: IIshikawaCategory) => {
        const target = event.target as HTMLSpanElement
        setCurrentCategory(target.innerHTML)
        setOpenModal(true)
        setEditing(false)
        setTypeModal('cause')
    }
    /**
     * Evento change value para categorias e subcategorias do diagrama
     * @param event 
     * @param category 
     */
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {

    }

    const handleBlur = (event: FocusEvent<HTMLElement>, category: IIshikawaCategory) => {
        category.editing = false
    }

    useEffect(() => {
        setCurrentDiagram(data)
    }, [data])

    /**
     * Evento chamado ao clicar em feachar o modal
     */
    const handleCloseModal = () => {
        setOpenModal(false)
        setCurrentCategory('')
        setValue('selectedValue', '')
        setEditing(false)
        setEditingCauseIndex(0)
    }
    /**
     * Metodo usando para editar uma causa, coloca informações no state para que o item de array possa ser substituido
     * @param event 
     * @param category 
     * @param causeIndex 
     * @param value 
     */
    const handleClickCause = (event: MouseEvent<HTMLSpanElement>, category: IIshikawaCategory, causeIndex: number, value: string) => {
        const target = event.target as HTMLSpanElement
        setCurrentCategory(category.title)
        setValue('selectedValue', value)
        setTypeModal('cause')
        setOpenModal(true)
        setEditing(true)
        setEditingCauseIndex(causeIndex)
    }

    /**
     * Metodo invocado cada vez que se clicar em Salvar no modal para adiconar uma causa nova
     * @param data 
     */
    const handleAddCause = (data: { selectedValue: string }) => {
        let diagram: IIshikawaDiagram = { ...currentDiagram }
        diagram.categories.forEach((cat) => {
            if (cat.title === currentCategory) {
                if (isEditing) {
                    cat.causes[editingCauseIndex] = selectedValue
                } else {
                    cat.causes.push(selectedValue)
                }
            }
        })
        setCurrentDiagram(diagram)
        setOpenModal(false)
        setValue('selectedValue', '')
    }
    /**
     * Metodo invocado cada vez que se clicar em Salvar no modal para adicionar uma descrição
     * @param data 
     */
    const handleAddDescription = (data: { selectedValue: string }) => {

        let diagram: IIshikawaDiagram = { ...currentDiagram }
        diagram.problem = selectedValue
        setCurrentDiagram(diagram)
        setOpenModal(false)
        setValue('selectedValue', '')
    }

    return (
        <Containner data-testid="test-ishikawa-container">
            <Modal
                register={register}
                handleSubmit={handleSubmit}
                handleAddCause={handleAddCause}
                handleAddDescription={handleAddDescription}
                isOpen={isOpenModal}
                handleCloseModal={handleCloseModal}
                categoryName={currentCategory}
                type={typeModal}
                isEditing={isEditing}
            />
            <Chart>
                <Causes>
                    <GetTopCausesContent
                        diagram={currentDiagram}
                        handleChange={handleChange}
                        handleClickCause={handleClickCause}
                        handleBlur={handleBlur}
                        handleDoubleClick={handleDoubleClick}
                    />
                    <Line />
                    <GetBottomCausesContent
                        diagram={currentDiagram}
                        handleChange={handleChange}
                        handleClickCause={handleClickCause}
                        handleBlur={handleBlur}
                        handleDoubleClick={handleDoubleClick}
                    />
                </Causes>
                <EffectContainner>
                    <EffectItem>
                        <TitleEffect>
                            {`Efeito inesperado: `}
                            <TitleEffect className='font-bold'>
                                {currentDiagram && currentDiagram.problem}
                            </TitleEffect>
                        </TitleEffect>
                    </EffectItem>
                </EffectContainner>

            </Chart>
        </Containner>
    )
}

export default Ishikawa